
shadow.loader.set_load_start('app-handlers');